<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('dispositifPublicitaire.titleInOnglet.info') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('dispositifPublicitaire.couleurRal')">
          <b-input v-model="dispositifTechnique.couleurRAL"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('dispositifPublicitaire.arretBus')">
          <b-input v-model="dispositifPublicitaire.arretBus"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field
          :label="$t('dispositifPublicitaire.valeurAcquisition')" >
          <input-currency v-model="dispositifTechnique.valeurAcquisition"
                          isNumber="true">
          </input-currency>
        </b-field>
      </div>
      <div class="column is-3">
        <div class="mgt-20px">
          <b-checkbox v-model="dispositifTechnique.publicitaire" class="mgt-10px">
            <p class="has-text-default has-text-weight-bold">
              {{ $t('dispositifPublicitaire.publicitaire') }}
            </p>
          </b-checkbox>
        </div>
      </div>
      <div class="column is-3">
        <b-field
          :label="$t('dispositifPublicitaire.codeTimeo')" >
          <b-input v-model="dispositifPublicitaire.codeTimeo">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('dispositifPublicitaire.eclairable')">
          <b-checkbox v-model="dispositifTechnique.eclairable">
          </b-checkbox>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('dispositifPublicitaire.avecCaissonPub')">
          <b-checkbox v-model="dispositifPublicitaire.avecCaissonPub">
          </b-checkbox>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import inputCurrency from '@/components/general/inputCurrency';
import messageErreur from '@/services/general/messageErreur';

export default {
  props: {
    dispositifPublicitaire: {
      type: Object,
      required: true,
    },
    dispositifTechnique: {
      type: Object,
      required: true,
    },
  },
  components: {
    inputCurrency,
  },
  mounted() {
    try {
      if (this.$route.params.idDispositif) {
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.dispositifPublicitaire.code }));
      }
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
